module.exports = __webpack_public_path__ + "static/img/card.8eecec7e.png";